import { waitForHydrated } from "@trumpf/ux.utils";

function promiseHydrated(element: HTMLElement) {
    return new Promise<HTMLElement>((resolve) =>
        waitForHydrated(element, () => resolve(element))
    );
}

export async function getCheckedCheckboxesValues(
    allCheckboxes: HTMLUxCheckboxListItemElement[]
) {
    const checkedCheckboxes: string[] = [];
    const hydratedCheckboxes = await Promise.all(
        allCheckboxes.map((checkbox) => promiseHydrated(checkbox))
    );
    hydratedCheckboxes.forEach((checkbox) => {
        const checkboxInput = checkbox.querySelector("input");
        if (checkboxInput.checked) {
            checkedCheckboxes.push(checkboxInput.value);
        }
    });
    return checkedCheckboxes;
}
